import { createLucideIcon } from "lucide-react";

export const Sorting3 = createLucideIcon(
    "Sorting3",
    [
        [
            "path",
            {
                d: "M10 4H21",
                key: "mu60sp",
            },
        ],
        [
            "path",
            {
                d: "M11 8L20 8",
                key: "1dpjiw",
            },
        ],
        [
            "path",
            {
                d: "M12 12L18 12",
                key: "mpsy8h",
            },
        ],
        [
            "path",
            {
                d: "M14 16L16 16",
                key: "2d0d3t",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C4.7998 21 3.4915 19.0057 3 18.5",
                key: "nkc38e",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C6.2002 21 7.5085 19.0057 8 18.5",
                key: "1yvnig",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21V3",
                key: "1mc4pb",
            },
        ],
    ],
);
